import { Link } from 'react-router-dom';
import './HeroBanner.css';

export default function HeroBanner({ title, subtitle, breadcrumb, ctaText, ctaLink, large }) {
  return (
    <section className={`hero-banner ${large ? 'hero-banner--large' : ''}`}>
      <div className="hero-banner__overlay" />
      <div className="container hero-banner__content">
        {breadcrumb && (
          <div className="hero-banner__breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>{breadcrumb}</span>
          </div>
        )}
        <h1 className="hero-banner__title">{title}</h1>
        {subtitle && <p className="hero-banner__subtitle">{subtitle}</p>}
        {ctaText && ctaLink && (
          <Link to={ctaLink} className="btn btn-primary hero-banner__cta">
            {ctaText}
          </Link>
        )}
      </div>
    </section>
  );
}
